<template>
  <div class="tab-panel-content">
    <div class="receiver-layout">
      <div class="group-panel">
        <div class="gp-head">
          <span class="gp-title">接收组管理</span>
          <v-btn style="height: 32px;" color="primary" density="compact" prepend-icon="mdi-plus" :disabled="!canEditReceiver" @click="handleOpenNewGroupDialog">
            新建组
          </v-btn>
        </div>
        <div class="gp-body">
          <div v-for="(g, gi) in groups" :key="g.id" class="grp-card">
            <div class="grp-head">
              <span class="grp-name">{{ g.name }}</span>
              <div class="grp-actions">
                <el-button size="small" link :disabled="!canEditReceiver" @click="handleOpenRenameGroupDialog(gi)"><span class="mdi mdi-pencil-outline"></span></el-button>
                <el-button size="small" link type="danger" :disabled="!canEditReceiver" @click="handleOpenRemoveGroupDialog(gi)"><span class="mdi mdi-delete-outline"></span></el-button>
              </div>
            </div>
            <div class="grp-section-label"><span class="mdi mdi-account-outline"></span> 接收人员</div>
            <div v-if="g.members.length" class="grp-members">
              <span v-for="(m, mi) in g.members" :key="mi" class="grp-member">
                {{ m }}
                <span class="remove-btn" :class="{ disabled: !canEditReceiver }" @click="handleRemoveMember(gi, mi)">&times;</span>
              </span>
            </div>
            <div v-else class="grp-empty">暂无成员</div>
            <div class="grp-add-row">
              <el-input v-model="g._newMember" size="small" placeholder="输入工号" style="flex: 1" :disabled="!canEditReceiver" @keyup.enter="handleAddMember(gi)" />
              <el-button size="small" :disabled="!canEditReceiver" @click="handleAddMember(gi)">添加</el-button>
            </div>
            <div class="grp-section-label"><span class="mdi mdi-office-building-outline"></span> 关联电站</div>
            <div v-if="g.stations.length" class="grp-stations">
              <span v-for="(sid, si) in g.stations" :key="si" class="grp-station-tag">
                <span>{{ getStationName(sid) }}</span>
                <span class="mdi mdi-close-circle" :class="{ disabled: !canEditReceiver }" @click="handleRemoveStationFromGroup(gi, si)"></span>
              </span>
            </div>
            <div v-else class="grp-empty">暂未关联电站</div>
            <div class="grp-add-row">
              <el-select
                :key="g.id + '-' + g.stations.length"
                size="small"
                placeholder="选择电站..."
                style="flex: 1"
                filterable
                :disabled="!canEditReceiver"
                :model-value="''"
                @change="handlePickStationForGroup(gi, $event)"
              >
                <el-option v-for="s in availableStationsForGroup(g.id)" :key="s.id" :label="s.name" :value="s.id" />
              </el-select>
            </div>
            <div class="grp-section-label"><span class="mdi mdi-bell-outline"></span> 推送途径</div>
            <div class="grp-channels">
              <el-checkbox v-for="ch in channelOptions" :key="ch.value" v-model="g.channels[ch.value]" size="small" :disabled="!canEditReceiver">{{
                ch.label
              }}</el-checkbox>
            </div>
          </div>
          <div v-if="!groups.length" style="text-align: center; color: var(--text-muted); padding: 24px 0">
            尚未创建接收组<br />点击上方按钮新建
          </div>
        </div>
      </div>

      <div class="assign-panel">
        <div class="ap-head">
          <div class="ap-head-row">
            <span class="mdi mdi-sitemap-outline" style="color: var(--primary)"></span>
            <span>推送关联总览</span>
            <span style="font-size: 12px; color: var(--text-muted); font-weight: 400; margin-left: 8px">电站告警 → 所属组 → 接收人</span>
          </div>
        </div>
        <div class="ap-body">
          <div class="overview-grid">
            <div v-for="g in groups" :key="g.id" class="overview-group-card">
              <div class="ovg-head">
                <span class="ovg-name">{{ g.name }}</span>
                <span class="ovg-meta">{{ g.members.length }} 人 · {{ g.stations.length }} 个电站</span>
              </div>
              <div class="ovg-row">
                <span class="ovg-label">接收人</span>
                <div class="ovg-tags">
                  <span v-if="!g.members.length" class="ovg-tag member" style="color: var(--text-muted)">未配置</span>
                  <span v-for="m in g.members" :key="m" class="ovg-tag member">{{ m }}</span>
                </div>
              </div>
              <div class="ovg-row">
                <span class="ovg-label">关联电站</span>
                <div class="ovg-tags">
                  <span v-if="!g.stations.length" class="ovg-tag station" style="color: var(--text-muted)">未配置</span>
                  <span v-for="sid in g.stations" :key="sid" class="ovg-tag station">{{ getStationName(sid) }}</span>
                </div>
              </div>
              <div class="ovg-row">
                <span class="ovg-label">推送途径</span>
                <div class="ovg-tags">
                  <span v-if="!Object.values(g.channels).some(Boolean)" class="ovg-tag channel" style="color: var(--text-muted)"
                    >未配置</span
                  >
                  <span v-for="ch in channelOptions" :key="ch.value" v-show="g.channels[ch.value]" class="ovg-tag channel">{{
                    ch.label
                  }}</span>
                </div>
              </div>
            </div>
            <div v-if="!groups.length" style="text-align: center; color: var(--text-muted); padding: 40px 0">请先在左侧创建接收组</div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="newGroupDialogOpen" max-width="420" scroll-strategy="close">
      <v-card rounded="lg">
        <v-card-title class="text-subtitle-1 font-weight-semibold">新建接收组</v-card-title>
        <v-card-text class="pt-2">
          <p class="text-body-2 text-medium-emphasis mb-3">请输入组名称，创建后可配置成员与关联电站。</p>
          <v-text-field
            v-model="newGroupName"
            label="组名称"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            :error-messages="newGroupNameError"
            autofocus
            clearable
            @update:model-value="onNewGroupNameInput"
            :disabled="!canEditReceiver"
            @keyup.enter="handleConfirmNewGroup"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn variant="text" class="text-none" @click="closeNewGroupDialog">取消</v-btn>
          <v-btn color="primary" variant="flat" rounded="lg" class="text-none" :disabled="!canEditReceiver" @click="handleConfirmNewGroup">创建</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="renameGroupDialogOpen" max-width="420" scroll-strategy="close">
      <v-card rounded="lg">
        <v-card-title class="text-subtitle-1 font-weight-semibold">重命名</v-card-title>
        <v-card-text class="pt-2">
          <p class="text-body-2 text-medium-emphasis mb-3">修改接收组显示名称。</p>
          <v-text-field
            v-model="renameGroupName"
            label="组名称"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            :error-messages="renameGroupNameError"
            autofocus
            clearable
            @update:model-value="onRenameGroupNameInput"
            :disabled="!canEditReceiver"
            @keyup.enter="handleConfirmRenameGroup"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn variant="text" class="text-none" @click="closeRenameGroupDialog">取消</v-btn>
          <v-btn color="primary" variant="flat" rounded="lg" class="text-none" :disabled="!canEditReceiver" @click="handleConfirmRenameGroup">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeGroupDialogOpen" max-width="420" scroll-strategy="close">
      <v-card rounded="lg">
        <v-card-title class="text-subtitle-1 font-weight-semibold">删除确认</v-card-title>
        <v-card-text class="text-body-2 pt-2">
          确定删除接收组「<strong>{{ removeGroupTargetName }}</strong>」吗？删除后需重新配置关联关系。
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn variant="text" class="text-none" @click="closeRemoveGroupDialog">取消</v-btn>
          <v-btn color="error" variant="flat" rounded="lg" class="text-none" :disabled="!canEditReceiver" @click="handleConfirmRemoveGroup">删除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { useAlarmConfig } from '../useAlarmConfig'
import { checkPermi } from '@/utils/permission'
import { computed } from 'vue'

const {
  groups,
  channelOptions,
  addMember,
  removeMember,
  getStationName,
  onPickStationForGroup,
  removeStationFromGroup,
  availableStationsForGroup,
  newGroupDialogOpen,
  newGroupName,
  newGroupNameError,
  openNewGroupDialog,
  closeNewGroupDialog,
  onNewGroupNameInput,
  confirmNewGroup,
  renameGroupDialogOpen,
  renameGroupName,
  renameGroupNameError,
  openRenameGroupDialog,
  closeRenameGroupDialog,
  onRenameGroupNameInput,
  confirmRenameGroup,
  removeGroupDialogOpen,
  removeGroupTargetName,
  openRemoveGroupDialog,
  closeRemoveGroupDialog,
  confirmRemoveGroup,
} = useAlarmConfig()

const canEditReceiver = computed(() => checkPermi(['ops:alarmConfig:receiver']))

function runWithReceiverPerm(fn, ...args) {
  if (!canEditReceiver.value) return
  fn(...args)
}

function handleOpenNewGroupDialog() {
  runWithReceiverPerm(openNewGroupDialog)
}

function handleOpenRenameGroupDialog(index) {
  runWithReceiverPerm(openRenameGroupDialog, index)
}

function handleOpenRemoveGroupDialog(index) {
  runWithReceiverPerm(openRemoveGroupDialog, index)
}

function handleAddMember(index) {
  runWithReceiverPerm(addMember, index)
}

function handleRemoveMember(groupIndex, memberIndex) {
  runWithReceiverPerm(removeMember, groupIndex, memberIndex)
}

function handlePickStationForGroup(index, stationId) {
  runWithReceiverPerm(onPickStationForGroup, index, stationId)
}

function handleRemoveStationFromGroup(groupIndex, stationIndex) {
  runWithReceiverPerm(removeStationFromGroup, groupIndex, stationIndex)
}

function handleConfirmNewGroup() {
  runWithReceiverPerm(confirmNewGroup)
}

function handleConfirmRenameGroup() {
  runWithReceiverPerm(confirmRenameGroup)
}

function handleConfirmRemoveGroup() {
  runWithReceiverPerm(confirmRemoveGroup)
}
</script>

<style scoped lang="scss">
.receiver-layout {
  display: flex;
  gap: 16px;
  min-height: 480px;
}

.disabled {
  opacity: 0.45;
  pointer-events: none;
}

.group-panel {
  width: 300px;
  flex-shrink: 0;
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: blur(6px);
}

.group-panel .gp-head {
  padding: 14px 16px;
  border-bottom: 1px solid var(--color-td-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.group-panel .gp-head .gp-title {
  font-size: 14px;
  font-weight: 600;
}

.group-panel .gp-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.grp-card {
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 8px;
  transition: border-color 0.2s;
}

.grp-card:hover {
  border-color: var(--primary);
}

.grp-card .grp-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.grp-card .grp-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.grp-card .grp-actions {
  display: flex;
  gap: 4px;
}

.grp-card .grp-members {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.grp-card .grp-member {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background: var(--surface-muted);
  color: var(--text-secondary);
}

.grp-card .grp-member .remove-btn {
  cursor: pointer;
  margin-left: 4px;
  color: var(--text-muted);
  font-size: 13px;
}

.grp-card .grp-member .remove-btn:hover {
  color: var(--danger);
}

.grp-card .grp-add-row {
  display: flex;
  gap: 4px;
  margin-top: 6px;
}

.grp-section-label {
  font-size: 11px;
  color: var(--text-muted);
  margin: 8px 0 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.grp-stations {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.grp-station-tag {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--color-success) 12%, #ffffff);
  color: color-mix(in srgb, var(--color-success) 55%, #1a3d24);
  border: 1px solid color-mix(in srgb, var(--color-success) 28%, #ffffff);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 200px;
}

.grp-station-tag span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grp-station-tag .mdi {
  cursor: pointer;
  font-size: 12px;
  flex-shrink: 0;
}

.grp-station-tag .mdi:hover {
  color: var(--danger);
}

.grp-channels {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.grp-card .grp-empty {
  font-size: 12px;
  color: var(--text-muted);
}

.assign-panel {
  flex: 1;
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: blur(6px);
}

.assign-panel .ap-head {
  padding: 14px 20px;
  border-bottom: 1px solid var(--color-td-border);
  font-size: 14px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ap-head-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.overview-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.overview-group-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 14px 16px;
  transition: border-color 0.2s;
}

.overview-group-card:hover {
  border-color: var(--primary);
}

.ovg-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ovg-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.ovg-meta {
  font-size: 11px;
  color: var(--text-muted);
}

.ovg-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 6px;
}

.ovg-label {
  font-size: 12px;
  color: var(--text-muted);
  min-width: 52px;
  padding-top: 2px;
  flex-shrink: 0;
}

.ovg-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1;
}

.ovg-tag {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
}

.ovg-tag.member {
  background: var(--surface-muted);
  color: var(--text-secondary);
}

.ovg-tag.station {
  background: color-mix(in srgb, var(--color-success) 12%, #ffffff);
  color: color-mix(in srgb, var(--color-success) 55%, #1a3d24);
}

.ovg-tag.channel {
  background: color-mix(in srgb, var(--color-primary) 10%, #ffffff);
  color: var(--color-primary);
}

.assign-panel .ap-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

@media (prefers-reduced-motion: reduce) {
  .grp-card {
    transition: none;
  }
}

@media (max-width: 960px) {
  .receiver-layout {
    flex-direction: column;
  }

  .group-panel {
    width: 100%;
  }
}
</style>
